import type { MenuItem } from '@/models'

const MORE_ITEM_ID = 9999

const navigationMoreItem: MenuItem = {
  id: MORE_ITEM_ID,
  parentId: null,
  title: 'Ещё',
  href: '',
  orderIndex: MORE_ITEM_ID,
  class: '',
  isPinned: false,
  imageId: undefined,
}
/**
 * обновляем меню в зависимости от того, какой длины меню нужно показать
 * все лишние элементы отправляются в подменю / возвращается из подменю
 * @param menu текущее меню
 * @param currentItems массив пунктов меню, исключающий подменю
 * @param submenu первый попавшийся пункт меню, имеющий подменю, если такой существует
 * @param length количество пунктов меню, которые необходимо показать на первом уровне
 */
const updateNavigation = (
  menu: Undefinable<MenuItem[]>,
  currentItems: MenuItem[],
  submenu: Undefinable<MenuItem>,
  length: number,
): Undefinable<MenuItem[]> => {
  if (!menu) return

  const currentMenu = [...menu]

  // если больше, чем нужно
  if (currentItems.length > length) {
    // получаем лишние элементы
    const excessItems = currentItems.splice(length - currentItems.length)

    let parentId = submenu?.id

    // если подменю не существует, добавляем свой пункт для подменю

    const containMoreItem = currentMenu.find((item) => item.id === MORE_ITEM_ID)

    if (!parentId && !containMoreItem) {
      currentMenu.push(navigationMoreItem)
      parentId = navigationMoreItem.id
    }

    return changeNavigationItemsList(currentMenu, excessItems, parentId)
  } else if (currentItems.length < length) {
    const submenuItems = submenu?.submenu
    // получаем недостающие элементы из субменю
    const missingItems = submenuItems?.splice(currentItems.length - length)

    if (!submenu || !submenuItems?.length)
      menu = currentMenu.filter((item) => item.id !== MORE_ITEM_ID)

    return changeNavigationItemsList(menu, missingItems || [])
  }

  if (!submenu || !submenu.submenu?.length)
    menu = currentMenu.filter((item) => item.id !== MORE_ITEM_ID)

  return menu
}

/**
 * функция перемещает лишние элементы в подменю / возвращает их из подменю
 * 1. устанавливает parentId для всех перемещаемых элементов
 * 2. удаляет перезаписанные элементы из текущего меню
 * @param currentMenu текущее меню
 * @param items список лишних или недостающих в верхнем меню элементов
 * @param parentId id элемента меню, в котором лежит подменю
 */
const changeNavigationItemsList = (
  currentMenu: MenuItem[],
  items: MenuItem[],
  parentId?: number,
): Undefinable<MenuItem[]> => {
  items.forEach((item) => {
    const itemIndex = currentMenu.findIndex(
      (menuItem) => menuItem.id === item.id,
    )

    currentMenu.splice(itemIndex, 1)
  })

  const menuWithParentIds = items.map((item) => {
    if (parentId) {
      if (item.id !== parentId) item.parentId = parentId
    } else {
      item.parentId = null
    }

    return item
  })

  return [...currentMenu, ...menuWithParentIds]
}

const useNavigations = () => ({
  updateNavigation,
})

export { useNavigations }
